var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    attrs: {
      name: _vm.$attrs.name,
      rules: _vm.rules,
      vid: _vm.$attrs.vid,
      tag: "div"
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var validate = ref.validate
            var errors = ref.errors
            return [
              _c("div", { staticClass: "ds-control-box" }, [
                _c(
                  "div",
                  {
                    staticClass: "ds-control-box__body",
                    class: _vm.value ? "is-value" : ""
                  },
                  [
                    _vm._t("default", function() {
                      return [
                        _vm.$attrs.type === "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerValue,
                                  expression: "innerValue"
                                }
                              ],
                              ref: "input",
                              staticClass:
                                "ds-control-input ds-control-input--style_default effect-line-input",
                              class: _vm.className,
                              attrs: {
                                disabled: _vm.$attrs.disabled,
                                placeholder: _vm.$attrs.placeholder,
                                id: _vm.$attrs.id,
                                min: _vm.$attrs.min,
                                type: "text",
                                type: "checkbox"
                              },
                              domProps: {
                                value: _vm.value,
                                checked: Array.isArray(_vm.innerValue)
                                  ? _vm._i(_vm.innerValue, _vm.value) > -1
                                  : _vm.innerValue
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.innerValue,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = _vm.value,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.innerValue = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.innerValue = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.innerValue = $$c
                                  }
                                }
                              }
                            })
                          : _vm.$attrs.type === "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerValue,
                                  expression: "innerValue"
                                }
                              ],
                              ref: "input",
                              staticClass:
                                "ds-control-input ds-control-input--style_default effect-line-input",
                              class: _vm.className,
                              attrs: {
                                disabled: _vm.$attrs.disabled,
                                placeholder: _vm.$attrs.placeholder,
                                id: _vm.$attrs.id,
                                min: _vm.$attrs.min,
                                type: "text",
                                type: "radio"
                              },
                              domProps: {
                                value: _vm.value,
                                checked: _vm._q(_vm.innerValue, _vm.value)
                              },
                              on: {
                                change: function($event) {
                                  _vm.innerValue = _vm.value
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerValue,
                                  expression: "innerValue"
                                }
                              ],
                              ref: "input",
                              staticClass:
                                "ds-control-input ds-control-input--style_default effect-line-input",
                              class: _vm.className,
                              attrs: {
                                disabled: _vm.$attrs.disabled,
                                placeholder: _vm.$attrs.placeholder,
                                id: _vm.$attrs.id,
                                min: _vm.$attrs.min,
                                type: "text",
                                type: _vm.$attrs.type
                              },
                              domProps: {
                                value: _vm.value,
                                value: _vm.innerValue
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.innerValue = $event.target.value
                                }
                              }
                            }),
                        _c("span", { staticClass: "focus-border" })
                      ]
                    }),
                    _vm._t("label", function() {
                      return [
                        _c(
                          "label",
                          {
                            staticClass: "ds-control-box__caption",
                            attrs: { for: _vm.$attrs.id }
                          },
                          [
                            _c("span", { staticClass: "ds-caption" }, [
                              _vm._v(" " + _vm._s(_vm.$attrs.placeholder))
                            ])
                          ]
                        )
                      ]
                    }),
                    _vm._t(
                      "error",
                      function() {
                        return [
                          _c("transition", { attrs: { name: "fade" } }, [
                            errors.length
                              ? _c(
                                  "span",
                                  { staticClass: "help--type_error" },
                                  [_vm._v(_vm._s(errors[0]))]
                                )
                              : _vm._e()
                          ])
                        ]
                      },
                      { errors: errors }
                    )
                  ],
                  2
                )
              ])
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72e74fcf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e74fcf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/InputGroup.vue
// module id = 78
// module chunks = 0